export enum CustomerStatus {
  GUEST_USER = 'GUEST_USER',
  SEMI_VERIFIED_USER = 'Semi_Verified_User',
}
